import React, {Component} from 'react';
import Modal from 'react-bootstrap-modal';
import {t} from 'l10n';

import {Form, ErrorContainer} from 'form';

import ModalConfimEmail from './ModalConfimEmail';

import '../../sass/modals/modalChangeEmail.scss';

import {changeEmail} from 'backend-helpers/member';

class ModalChangeEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newEmail: null,
            modalConfimEmail: false
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formData, setErrors) {
        let {
            closeFn,
            setStateNewEmail
        } = this.props;

        if (formData.email !== formData.email_confirmation) {
            setErrors(t('Email address and confirmation do not match.'));
            return;
        }

        changeEmail(formData).then(() => {
            this.setState({
                modalConfimEmail: true,
                newEmail: formData.email,
            });

            setStateNewEmail ? setStateNewEmail(formData.email) : false;

            closeFn();
        }).catch(function(error) {
            setErrors(error.message);
        });
    }

    viewModalConfimEmail() {
        const { modalConfimEmail } = this.state;

        this.setState({modalConfimEmail: !modalConfimEmail});
    }

    render() {
        const {show, closeFn, user} = this.props;

        const { 
            newEmail,
            modalConfimEmail
        } = this.state;

        return (
            <div>
                {!modalConfimEmail ? (
                    <Modal className="change-email" show={show} onHide={closeFn}>
                        <Modal.Body>
                            <div className="close" onClick={closeFn}></div>
                            <p className="modal-title">{t('Change email')}</p>
                            <div className="form">
                                <Form onSubmit={this.onSubmit}>
                                    <ErrorContainer data-errorcontainer={true} />
                                    {user ? <div className="form-group"><label>{t('Current email address:')}</label><span>{user.email}</span></div> : null}
                                    <div className="form-group">
                                        <label>{t('New email address:')}</label>
                                        <input type="email" name="email"/>
                                    </div>
                                    <div className="form-group">
                                        <label>{t('New email address again:')}</label>
                                        <input type="email" name="email_confirmation"/>
                                    </div>
                                    <div className="form-group-buttons">
                                        <button type="submit" className="save-name">{t('Save')}</button>
                                        <button type="button" className="close-name" onClick={closeFn}>{t('Cancel')}</button>
                                    </div>
                                </Form>
                            </div>
                        </Modal.Body>
                    </Modal>
                ) : null}
                {modalConfimEmail ? <ModalConfimEmail newEmail={newEmail} closeFn={() => this.viewModalConfimEmail()}/> : null}
            </div>
        )
    }
}

export default ModalChangeEmail;


// WEBPACK FOOTER //
// ./src/components/modals/ModalChangeEmail.js